export default __webpack_public_path__ + "static/28d-card-canstar-award-bf36c73ba32e4645e9c572728b0e30ac.png";